// React
import React, { Fragment } from 'react';

// Ant Design
import { EditFilled } from '@ant-design/icons';

// UI Libraries
import H3Text from '@Uilib/h3Text';

// Helpers
import Helpers from '@Apis/helpers';

function ViewInvoiceAddresses({
  props, updateState, quickUpdateDisable
}) {

  const {
    user, selectedInvoice
  } = props;

  return (
    <Fragment>
      <div className="document-address-list">
        <div className="ant-row">
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__left">
              <div className="view-document__input-row__address-icon-wrapper">
                <H3Text text="Bill From" className="document-address__title" />
              </div>
              {selectedInvoice?.bill_from_address_info?.address1 && <H3Text text={selectedInvoice.bill_from_address_info.address1} className="document-address__details" />}
              {selectedInvoice?.bill_from_address_info?.address1 && (
                <H3Text
                  text={`${selectedInvoice?.bill_from_address_info?.city}, ${selectedInvoice?.bill_from_address_info?.state}, ${selectedInvoice?.bill_from_address_info?.postal_code}, ${selectedInvoice?.bill_from_address_info?.country}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__right">
              <div className="view-document__input-row__address-icon-wrapper">
                <H3Text text="Ship From" className="document-address__title" />
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="view-document__input-row__address-icon"
                  >
                    {!selectedInvoice?.shopify_order_id && !selectedInvoice?.unicommerce_invoice_code && !selectedInvoice?.irn && !selectedInvoice?.e_way_bills && quickUpdateDisable && (
                      <EditFilled
                        onClick={() => updateState({
                          selectedAddressType: 'TENANT_SHIP_FROM',
                          showAddressDrawer: true,
                        })}
                      />
                    )}
                  </div>
                )}
              </div>
              {selectedInvoice?.ship_from_address_info?.address1 && <H3Text text={selectedInvoice.ship_from_address_info.address1} className="document-address__details" />}
              {selectedInvoice?.ship_from_address_info?.address1 && (
                <H3Text
                  text={`${selectedInvoice?.ship_from_address_info?.city}, ${selectedInvoice?.ship_from_address_info?.state}, ${selectedInvoice?.ship_from_address_info?.postal_code}, ${selectedInvoice?.ship_from_address_info?.country}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="document-address-list">
        <div className="ant-row">
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__left">
              <div className="view-document__input-row__address-icon-wrapper">
                <H3Text text="Bill To" className="document-address__title" />
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="view-document__input-row__address-icon"
                  >

                    {!selectedInvoice?.shopify_order_id && !selectedInvoice?.unicommerce_invoice_code && !selectedInvoice?.irn && !selectedInvoice?.e_way_bills && quickUpdateDisable && (
                      <EditFilled
                        onClick={() => updateState({
                          selectedAddressType: 'TENANT_BILLING',
                          showAddressDrawer: true,
                        })}
                      />
                    )}
                  </div>
                )}
              </div>
              {selectedInvoice?.billing_address_info?.address1 && <H3Text text={selectedInvoice.billing_address_info.address1} className="document-address__details" />}
              {selectedInvoice?.billing_address_info?.address1 && (
                <H3Text
                  text={`${selectedInvoice?.billing_address_info?.city}, ${selectedInvoice?.billing_address_info?.state}, ${selectedInvoice?.billing_address_info?.postal_code}, ${selectedInvoice?.billing_address_info?.country}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__right">
              <div className="view-document__input-row__address-icon-wrapper">
                <H3Text text="Ship To" className="document-address__title" />
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="view-document__input-row__address-icon"
                  >
                    {!selectedInvoice?.shopify_order_id && !selectedInvoice?.unicommerce_invoice_code && !selectedInvoice?.irn && !selectedInvoice?.e_way_bills && quickUpdateDisable && (
                      <EditFilled
                        onClick={() => updateState({
                          selectedAddressType: 'TENANT_SHIPPING',
                          showAddressDrawer: true,
                        })}
                      />
                    )}
                  </div>
                )}
              </div>
              {selectedInvoice?.shipping_address_info?.address1 && <H3Text text={selectedInvoice.shipping_address_info.address1} className="document-address__details" />}
              {selectedInvoice?.shipping_address_info?.address1 && (
                <H3Text
                  text={`${selectedInvoice?.shipping_address_info?.city}, ${selectedInvoice?.shipping_address_info?.state}, ${selectedInvoice?.shipping_address_info?.postal_code}, ${selectedInvoice?.shipping_address_info?.country}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ViewInvoiceAddresses;